import Cookies from 'js-cookie';
import React from 'react';
import circleLogo from './../../img/circle-logo@2x.png';
import './Goto.css';

function fromQuery(predicates: Record<string, (val: string) => boolean>): Record<string, string> {
  const result: Record<string, string> = {};
  const query = new URLSearchParams(window.location.search);
  for (const [key, check] of Object.entries(predicates)) {
    const value = query.get(key);
    if (value && check(value)) {
      result[key] = value;
    }
  }
  return result;
}

export default class Goto extends React.PureComponent {

  render() {
    const queries = fromQuery({
      bearerToken: () => true,
      path: path => {
        let url: URL | undefined;
        try {
          url = new URL(path);
          return url.hostname === 'circledna.com' || url.hostname.endsWith('.circledna.com');
        } catch (err) {
          return false;
        }
      }
    });
    if (queries.bearerToken && queries.path) {
      Cookies.set('bearerToken', queries.bearerToken, {
        domain: 'circledna.com',
        secure: true,
      });
      window.location.href = queries.path;
    }
    return <div className="Goto">
      Please wait...
    </div>;
  }
}
